import { createSlice } from '@reduxjs/toolkit';
import ordersApi from './ordersApi';

const dataSlice = createSlice({
    name: 'orders',
    initialState: {
        listData: {},
        count: [],
        loading: true,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            ordersApi.endpoints.ordersList.matchFulfilled,
            (state, action) => {
                console.log(action.payload, 'action.payloadaction.payload');

                state.listData = action.payload; // Save the new data to the state
            }
        );
    },
});

export default dataSlice.reducer;
